<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12 8L24 8L24 20H22.4918V22H24C25.1046 22 26 21.1046 26 20L26 8C26 6.89543 25.1046 6 24 6H12C10.8954 6 10 6.89543 10 8L10 9.49685H12V8Z"
        />
        <path d="M10.5303 22H13.4012V20H10.5303V22Z" />
        <path d="M15.5303 16H10.5303V18H15.5303V16Z" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 14V24C6 25.1046 6.89543 26 8 26H18C19.1046 26 20 25.1046 20 24L20 14C20 12.8954 19.1046 12 18 12L8 12C6.89543 12 6 12.8954 6 14ZM8 24L8 14H18L18 24H8Z"
        />
    </svg>
</template>
